// extracted by mini-css-extract-plugin
module.exports = {"bookmark_section":"ProductCardBookmark_bookmark_section__1kMYZ"};